
import Header from '../component/Header';
import Footer from '../component/Footer';
import { Outlet } from 'react-router-dom';
import React from 'react';

export default function UserLayout({footerHide, simpleHeader}) {
  return (
    <>
      <Header simple={simpleHeader}/>
      <main>
          <Outlet />
      </main>
      <Footer footerHide={footerHide}/>
    </>
  )
}
